



































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import type { IIntroVideoStepConfig } from './Globals/types/ugc.t';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomText from '@/components/Globals/CustomText.vue';

import introVideos from '@/mixins/IntroVideos';

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomText,
    Swiper,
    SwiperSlide,
  },
  mixins: [introVideos],
})
export default class IntroVideos extends Vue {
  @Prop()
  assetsPath?: string;

  @Prop()
  onNext?: Function;

  @Prop()
  onSlideChange?: Function;

  @Prop()
  steps?: IIntroVideoStepConfig[];
}
